import o from "react";
import { IconContext as f, DefaultContext as d } from "./index145.mjs";
var l = function() {
  return l = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, l.apply(this, arguments);
}, g = function(e, r) {
  var t = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
    r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
};
function m(e) {
  return e && e.map(function(r, t) {
    return o.createElement(r.tag, l({
      key: t
    }, r.attr), m(r.child));
  });
}
function O(e) {
  return function(r) {
    return o.createElement(y, l({
      attr: l({}, e.attr)
    }, r), m(e.child));
  };
}
function y(e) {
  var r = function(t) {
    var n = e.attr, a = e.size, c = e.title, s = g(e, ["attr", "size", "title"]), u = a || t.size || "1em", i;
    return t.className && (i = t.className), e.className && (i = (i ? i + " " : "") + e.className), o.createElement("svg", l({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, t.attr, n, s, {
      className: i,
      style: l(l({
        color: e.color || t.color
      }, t.style), e.style),
      height: u,
      width: u,
      xmlns: "http://www.w3.org/2000/svg"
    }), c && o.createElement("title", null, c), e.children);
  };
  return f !== void 0 ? o.createElement(f.Consumer, null, function(t) {
    return r(t);
  }) : r(d);
}
export {
  O as GenIcon,
  y as IconBase
};
